import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface AnswerDto {
  id: number;
  questionId: number;
  answerText: string;
  order: number;
  points: number;
  topic?: string;
}

export interface AnswerUpdateDto {
  answerText: string;
  order: number;
  points: number;
  topic?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AnswerService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/answers';

  getByQuestionId(questionId: number): Observable<AnswerDto[]> {
    return this.http.get<AnswerDto[]>(`${this.apiUrl}/question/${questionId}`);
  }

  update(id: number, data: AnswerUpdateDto): Observable<AnswerDto> {
    return this.http.put<AnswerDto>(`${this.apiUrl}/${id}`, data);
  }
}